import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import logo1 from "../../assets/images/logo1.svg";
import loginToken from "../authComponents/localStorageItems/LoginTokin";
import baseURL from "../authComponents/baseURL/BaseURL";
import { ToastContainer, toast } from "react-toastify";

const Navbar = ({ userRole, userStatus, canRequestReview, userId, setLoginPopUp }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const handleLogOut = () => {
    localStorage.removeItem("authToken");
    window.location.reload();
  };

  const userIsRejected = () => {
    return userStatus.toLowerCase() === 'rejected';
  };

  const userResubmitted = () => {
    return userStatus.toLowerCase() === 'resubmitted';
  }

  const getReviewButtonClass = function() {
    if (userIsRejected() && canRequestReview == true) {
      return "text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 shadow-lg shadow-red-500/50 dark:shadow-lg dark:shadow-red-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
    } else {
      return "text-white bg-gray-300 cursor-not-allowed font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
    }
  }

  const getBannerText = () => {
    if (userIsRejected()) {
      return "Your profile is currently Rejected, Please update your profile from MyProfile Page and click this button to request admin for review of your updated infomation"
    } else {
      return "✅ Your review request has been sent successfully. Please wait while an admin reviews your updated information. You will be notified once a decision is made"
    }
  }

  const requestAccess = async () => {
    try {
      const respone = await baseURL.post(
        "/request_profile_review",
        { user_id: userId },
        { headers: { Authorization: `Bearer ${loginToken}` } }
      );
      if (respone.status == 200) {
        toast.success(respone.data.message);
        setTimeout(()=> {
          window.location.reload();
        }, 1000)
      } else {
        console.error("Failed to update user status:");
      }
    } catch(error) {

    }
  }

  const getRequestAccessButton = function() {
    if (canRequestReview) {
      return (
        <button type="button" onClick={()=> {requestAccess()}} className={getReviewButtonClass()}>Request Review</button>
      )
    } else {
      return (
        <button type="button" className={getReviewButtonClass()}> { userResubmitted() ? 'Request Sent' : 'Request Review' } </button>
      )
    }
  }

  const handleLoginPopUp = () => {
    if (!loginToken) {
      setLoginPopUp(true); // Show popup instead of navigating
    }
  };
  return (
    <>
      <ToastContainer />
      {(userIsRejected() || userResubmitted()) && <div className="flex row items-center justify-center gap-2 p-2 bg-gray-100">
        <p> { getBannerText() }</p>
        { getRequestAccessButton() }
      </div>}
      <nav className="bg-white shadow-md w-full sticky top-0 left-0 z-50">
        <div className="mx-auto px-4 flex justify-between items-center">
          {/* Logo Section */}
          <Link to="/">
            <img src={logo1} className="w-20 h-20" />
          </Link>

          {/* Hamburger Menu for Mobile */}
          <div className="md:hidden">
            <button onClick={toggleMenu} className="text-2xl text-[#730000]">
              {isOpen ? (
                <FaTimes className="w-6 h-6" />
              ) : (
                <FaBars className="w-6 h-6" />
              )}
            </button>
          </div>

          {/* Navigation Links */}
          <ul
            className={`md:flex md:space-x-4 text-black text-sm max-md:text-[16px] uppercase font-semibold absolute md:static left-0 w-full md:w-auto bg-white md:bg-transparent md:py-0 py-4 transition-all duration-300 ease-in-out ${isOpen ? "top-16 opacity-100" : "-top-96 opacity-0"
              } md:opacity-100`}
          >
            <Link to="/">
              <li className="hover:text-[#730000] cursor-pointer text-center md:text-left py-2">
                Home
              </li>
            </Link>
            <Link to="/about">
              <li className="hover:text-[#730000] cursor-pointer text-center md:text-left py-2">
                About
              </li>
            </Link>
            <Link to="/contact">
              <li className="hover:text-[#730000] cursor-pointer text-center md:text-left py-2">
                Contact Us
              </li>
            </Link>
            <Link to="/profile">
              <li
                onClick={handleLoginPopUp}
                className="hover:text-[#730000] cursor-pointer text-center md:text-left py-2"
              >
                My Profile
              </li>
            </Link>
            {/* Conditional Rendering */}
            {loginToken && userRole === "admin" && (
              <Link to="/admin/dashboard">
                <li className="text-white rounded bg-[#730000] py-2 px-4 cursor-pointer text-center md:text-left">
                  Dashboard
                </li>
              </Link>
            )}

            {!loginToken ? (
              <Link to="/login">
                <li className="text-white rounded bg-[#730000] py-2 px-4 cursor-pointer text-center md:text-left" style={{ fontFamily: "serif" }}>
                  Login/Register
                </li>
              </Link>
            ) : (
              <button
                onClick={handleLogOut}
                className="text-white rounded bg-[#730000] py-2 px-4 cursor-pointer text-center md:text-left"
              >
                Logout
              </button>
            )}
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
